import React from 'react';
import { Stack, Typography, Container, Paper, Grid, Link, Avatar, Chip, Box } from '@mui/material';
import { Email, Person, Business } from '@mui/icons-material';

export const Contact = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Stack spacing={1} sx={{ mb: 6, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" sx={{ fontWeight: 700 }}>
          Contact Us
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 500, mx: 'auto' }}>
          Interested in partnering with GoBotic or learning more about our solutions? Reach out directly.
        </Typography>
      </Stack>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper
            elevation={0}
            sx={{
              p: 4,
              borderRadius: 3,
              border: '1px solid rgba(255,255,255,0.08)',
              height: '100%',
              transition: 'all 0.3s ease',
              '&:hover': {
                borderColor: 'primary.main',
              },
            }}
          >
            <Stack spacing={3}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Avatar sx={{ bgcolor: 'primary.main', width: 48, height: 48 }}>
                  <Person />
                </Avatar>
                <Box>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Founder and Owner
                  </Typography>
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Karl Lilje
                  </Typography>
                </Box>
              </Stack>

              <Stack direction="row" spacing={2} alignItems="center">
                <Avatar sx={{ bgcolor: 'background.paper', border: '1px solid rgba(255,255,255,0.08)', width: 48, height: 48, color: 'primary.main' }}>
                  <Email />
                </Avatar>
                <Box>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Email
                  </Typography>
                  <Link
                    href="mailto:karl@gobotic.co.za"
                    variant="body1"
                    sx={{
                      color: 'primary.main',
                      textDecoration: 'none',
                      fontWeight: 500,
                      '&:hover': {
                        textDecoration: 'underline',
                      },
                    }}
                  >
                    karl@gobotic.co.za
                  </Link>
                </Box>
              </Stack>

              <Stack direction="row" spacing={2} alignItems="center">
                <Avatar sx={{ bgcolor: 'background.paper', border: '1px solid rgba(255,255,255,0.08)', width: 48, height: 48, color: 'secondary.main' }}>
                  <Business />
                </Avatar>
                <Box>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    Company
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    GOBOTIC
                  </Typography>
                </Box>
              </Stack>
            </Stack>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper
            elevation={0}
            sx={{
              p: 4,
              borderRadius: 3,
              border: '1px solid rgba(255,255,255,0.08)',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Stack spacing={2}>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Let's Build Together
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                Whether you're looking to deploy autonomous delivery robots, enhance security with AI-powered face recognition, or integrate our VBASE vector database into your stack — we're ready to help.
              </Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap">
                {['Robotics', 'AI/ML', 'Security', 'VBASE', 'Consulting'].map((tag) => (
                  <Chip
                    key={tag}
                    label={tag}
                    size="small"
                    sx={{
                      border: '1px solid rgba(255,255,255,0.12)',
                      bgcolor: 'background.paper',
                      color: 'text.secondary',
                    }}
                  />
                ))}
              </Stack>
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};
